module.exports = __webpack_public_path__ + "img/emoji_29.492df18d.png";